import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const diffuseEnrollments = (input: IdsInput) => {
  return restApiClient.url(constructApiUrl(API.centers.diffuseEnrollments.url, null)).post(input)
}
